import { TodoEffects } from './todo/todo.effects';


export const appEffects = [TodoEffects];
